import { qwCinemas } from "./qwCinemas";
import { qwDimensions } from "./qwDimensions";
import { qwFleet } from "./qwFleet";
import { qwMonarch } from "./qwMonarch";

const axiosClients = [qwFleet, qwDimensions, qwMonarch, qwCinemas];

export const setAxiosBearerToken = (token) => {
  for (const client of axiosClients) {
    client.defaults.headers.common.Authorization = token ? `Bearer ${token}` : "";
  }
};
